<template>
	<div>
		<citrus-product-basket-price
			v-if="showPrice"
			:base-price="price.full"
			:discount-price="price.price"
			:class="priceClass"
		></citrus-product-basket-price>
		<citrus-product-basket-quantity
			:class="'b-counter_catalog ' + quantityClass"
			:measure="measure"
			:max-quantity="maxQuantity"
			:id="productId"
			@change="tryChangeQuantity"
			:quantity="inBasket ? parseFloat(basketQuantity) : 1"
		></citrus-product-basket-quantity>
		<citrus-product-basket-button
			:metric-goal="metricGoal"
			:block-class="buttonClass"
			:quantity="parseFloat(currentQuantity)"
			:product-id="productId"
			:product-name="productName"
			:price="price"
			:detail-url="detailUrl"
			:basket-url="basketUrl"
			:has-sku="hasSku"
			:show-mobile="showMobile"
			:storage-type="storageType"
			:bind-global-basket="true"
			:custom-text="customText"
			:stock="stock"
			:isInBasket="inBasket"
		></citrus-product-basket-button>
	</div>
</template>
<script>
import {Vue} from "ui.vue";

export default {
	name: "ButtonWithQuantity",
	props: {
		measure: {
			type: Object,
			default: function () {
				return {
					id: 0,
					name: "",
					value: 1,
					ratio: 1,
				}
			}
		},
		maxQuantity: {
			type: Number,
			default: 9999
		},
		buttonClass: {
			type: String,
			default: ''
		},
		quantityClass: {
			type: String,
			default: ''
		},
		priceClass: {
			type: String,
			default: 'b-price_productCard'
		},
		showPrice: {
			type: Boolean,
			default: false
		},
		metricGoal: {
			type: [Boolean, String],
			default: false
		},
		stock: {
			type: [Object, Array],
			default: function () {
				return {}
			}
		}
	},
	computed: {
		/**
		 * Лежит ли товар в корзине
		 *
		 * @return {Boolean}
		 */
		inBasket() {
			return this.$store.getters['basket/check'](this.productId);
		},
		basketQuantity() {
			return this.$store.getters['basket/quantity'](this.productId);
		}
	},
	data: function () {
		return {
			priceData: {},
			currentQuantity: this.measure.ratio,
			request: false,
			newRequestCount: 0,
		};
	},
	methods: {
		onChange: function (params) {
			this.currentQuantity = params.quantity;

			if(this.inBasket) {
				Vue.event.$emit("Citrus.Vue.Product:changedBasket", params);
			}
		},
		tryChangeQuantity: function (params) {
			/* Если нет активных запросов */
			if (!this.request) {
				this.request = true;
			} else {
				this.newRequestCount++; /* счетчик одновременных запросов */
			}

			setTimeout(() => {
				/* К данному моменту есть новый запрос */
				if (this.newRequestCount) {
					this.newRequestCount--;
					return false;
				}

				/* отправка запроса */
				this.onChange(params);
				this.request = false;
				/* отправка запроса */

			}, 300);
		},
	}
}
</script>